import { __rest } from 'tslib';
import { isBoolean } from '@10d/tend-ui-utils/isBoolean';
import debounceFn from 'lodash/debounce';
import React from 'react';

const useDebouncedCallback = (fn, debounce) => {
    return React.useMemo(() => {
        if (!isBoolean(debounce)) {
            const _a = debounce || {}, { wait = 300 } = _a, options = __rest(_a, ["wait"]);
            return debounceFn(fn, wait, options);
        }
        if (!debounce)
            return fn;
        return debounceFn(fn, 300);
    }, [debounce, fn]);
};

export { useDebouncedCallback };
//# sourceMappingURL=useDebouncedCallback.js.map
